/**
 * @file index.tsx
 *
 * @fileoverview Exports job util functions.
 */

import { Job } from '~/jobiqo/types/types';
import { isOrganizationProfilePublished } from '~/jobiqo/components/Organization/utils/organizationStatus';

interface OrgProfileFromJob {
  /**
   * The organization profile name to display.
   *  This can be used wherever we display the organization
   * name extracted from the job entity.
   */
  label: string;
  /**
   * Flag to indicate if the organization profile is published.
   */
  isPublished: boolean;
}

/**
 * Returns an appropriate organization name to display.
 * This can be used wherever we display the organization
 * name extracted from the job entity.
 * @param {Job} job
 *  The job to extract organization profile from.
 * @returns {OrgProfileFromJob}
 *  Extracted data from job.
 */
export function getOrgProfileFromJob(job: Job): OrgProfileFromJob {
  const isPublished = isOrganizationProfilePublished(job.organizationProfile);
  const jobOrganizationName = job.organization ?? '';

  // If the organization profile is not published
  // return job organization prop.
  return {
    label: isPublished
      ? job.organizationProfile?.name ?? jobOrganizationName
      : jobOrganizationName,
    isPublished,
  };
}
